import { render, staticRenderFns } from "./PromoteWithdrawal.vue?vue&type=template&id=0062f36e&scoped=true"
import script from "./PromoteWithdrawal.vue?vue&type=script&lang=js"
export * from "./PromoteWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./PromoteWithdrawal.vue?vue&type=style&index=0&id=0062f36e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0062f36e",
  null
  
)

export default component.exports